import React from 'react';

import { MeetingDTO } from 'flow/types/Meetings';
import TodayMeetingItem from './TodayMeetingItem';

type Props = {
    meetings: MeetingDTO[];
};

const TodayMeetingsList = ({ meetings }: Props) => (
    <div className="flex flex-col gap-2">
        {meetings.map((meeting) => (
            <TodayMeetingItem key={meeting.id} meeting={meeting} />
        ))}
    </div>
);

export default TodayMeetingsList;
